module.exports = __webpack_public_path__ + "media/Selamat_Pengantin_Baru-Wann.2960ba94.mp3";